import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalConfigService } from './global-config.service';
import { AnamneseSectionDto } from '../models/anamnese-section.model';
import { IAnamneseQuestion } from '../models/anamnese-form-question.model';
import { ISectionFromAPI } from '../models/custom-anamnese-question.model';

export interface ICustomQuestionRequest {
  id?: string;
  label: string;
  order_in_section: number;
  is_required: boolean;
  type: string;
  help_text?: string;
  options?: Array<{
    value: string;
    label: string;
    order: number;
    triggersFreeText?: boolean;
  }>;
}

export interface IPublishCustomQuestionsRequest {
  questions: ICustomQuestionRequest[];
}

export interface IClinicQuestionsResponse {
  version: number;
  clinic_id: string;
  questions: Array<{
    id: string;
    label: string;
    placeholder?: string;
    type: string;
    order_in_section: number;
    is_required: boolean;
    help_text?: string;
    section_id: string;
    clinic_id: string;
    options?: Array<{
      id: string;
      value: string;
      label: string;
      triggersFreeText: boolean;
      order: number;
      selected?: boolean | null;
    }>;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class AnamneseCustomQuestionsService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/documents/anamnese';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }

  /**
   * Listar seções disponíveis
   */
  getSections(): Observable<ISectionFromAPI[]> {
    return this.http.get<ISectionFromAPI[]>(`${this.baseUrl}/sections`);
  }

  /**
   * Listar perguntas atuais da clínica
   */
  getClinicQuestions(cnpj: string): Observable<IClinicQuestionsResponse> {
    return this.http.get<IClinicQuestionsResponse>(`${this.baseUrl}/clinic/${cnpj}/questions`);
  }

  /**
   * Publicar novas perguntas da clínica
   */
  publishClinicQuestions(cnpj: string, request: IPublishCustomQuestionsRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/clinic/${cnpj}/questions/publish`, request);
  }

  copyClinicQuestions(sourceCnpj: string, targetCnpj: string): Observable<void> {
    const params = {
      source_cnpj: sourceCnpj,
      target_cnpj: targetCnpj
    };

    return this.http.post<void>(`${this.globalConfig.getApiUrl()}/companies/anamnese/copy`, null, { params });
  }
}
